import React, { useState } from 'react';
import { useTheme, THEMES } from '../ThemeContext';

const ThemeToggle = () => {
  const { theme, setTheme } = useTheme();
  const [open, setOpen] = useState(false);

  return (
    <div style={styles.wrapper}>
      {/* Theme cards — slide up when open */}
      {open && (
        <div style={styles.panel}>
          <p style={styles.panelTitle}>Choose Style</p>
          {Object.entries(THEMES).map(([key, t]) => (
            <button
              key={key}
              onClick={() => { setTheme(key); setOpen(false); }}
              style={{
                ...styles.themeBtn,
                ...(theme === key ? styles.themeBtnActive : {}),
              }}
            >
              <div style={styles.swatchRow}>
                {t.swatches.map((c, i) => (
                  <span key={i} style={{ ...styles.swatch, backgroundColor: c }} />
                ))}
              </div>
              <span style={styles.themeName}>
                {theme === key && <span style={styles.check}>✓ </span>}
                {t.icon} {t.label}
              </span>
            </button>
          ))}

        </div>
      )}

      {/* Floating toggle button */}
      <button
        onClick={() => setOpen(o => !o)}
        style={{ ...styles.fab, ...(open ? styles.fabOpen : {}) }}
        title="Switch theme"
        aria-label="Switch theme"
      >
        🎨
      </button>
    </div>
  );
};

const styles = {
  wrapper: {
    position: 'fixed',
    bottom: '24px',
    right: '24px',
    zIndex: 9999,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    gap: '10px',
  },
  fab: {
    width: '48px',
    height: '48px',
    borderRadius: '50%',
    border: '2px solid var(--card-border)',
    background: 'var(--card-bg)',
    boxShadow: 'var(--card-shadow)',
    fontSize: '1.4rem',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'transform 0.2s, box-shadow 0.2s',
    outline: 'none',
  },
  fabOpen: {
    transform: 'rotate(20deg) scale(1.1)',
  },
  panel: {
    background: 'var(--card-bg)',
    border: '1px solid var(--card-border)',
    borderRadius: '12px',
    boxShadow: 'var(--card-shadow)',
    padding: '14px 16px',
    minWidth: '190px',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  panelTitle: {
    margin: '0 0 4px 0',
    fontFamily: 'var(--font-heading)',
    fontSize: '0.8rem',
    letterSpacing: '1px',
    color: 'var(--accent-gold)',
    textShadow: 'var(--accent-gold-glow-dim)',
    textTransform: 'uppercase',
  },
  themeBtn: {
    background: 'rgba(0,0,0,0.3)',
    border: '1px solid var(--detail-border)',
    borderRadius: '8px',
    padding: '8px 10px',
    cursor: 'pointer',
    textAlign: 'left',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
    transition: 'border-color 0.2s, background 0.2s',
  },
  themeBtnActive: {
    borderColor: 'var(--accent-gold)',
    background: 'rgba(255,235,59,0.06)',
  },
  swatchRow: {
    display: 'flex',
    gap: '4px',
  },
  swatch: {
    width: '16px',
    height: '16px',
    borderRadius: '50%',
    border: '1px solid rgba(255,255,255,0.15)',
    display: 'inline-block',
  },
  themeName: {
    fontFamily: 'var(--font-body)',
    fontWeight: 700,
    fontSize: '0.88rem',
    color: 'var(--text-secondary)',
  },
  check: {
    color: 'var(--accent-gold)',
  },
};

export default ThemeToggle;
